var _defs, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMirandaMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Miranda Software") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 6,
    y1: 6,
    x2: 94,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b1220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07111f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent-top",
    x1: 22,
    y1: 18,
    x2: 78,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b36bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d28d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent-bottom",
    x1: 22,
    y1: 48,
    x2: 78,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67e8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#22d3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stroke-grad",
    x1: 6,
    y1: 6,
    x2: 94,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06b6d4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 90,
    height: 90,
    rx: 26,
    fill: "url(#bg)",
    stroke: "url(#stroke-grad)",
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 37 50 20l28 17-7 11-21-13-21 13-7-11Z",
    fill: "url(#accent-top)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 44 28 17 28-17v29l-11 7V63L50 73 33 63v17l-11-7V44Z",
    fill: "#f8fafc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32 70 18 11 18-11v9L50 90 32 79v-9Z",
    fill: "url(#accent-bottom)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirandaMark);
export default __webpack_public_path__ + "static/media/miranda-mark.2ec159187123d763885f0822933acfe3.svg";
export { ForwardRef as ReactComponent };